import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestService } from 'src/app/shared/services/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class BuscasService {
  constructor(private _requestService: RequestService) {}

  listResponsible(): Observable<any> {
    return this._requestService.requestMethod(
      `work/Responsibles`,
      'GET',
      true,
      null,
    );
  }

  listActions(): Observable<any> {
    return this._requestService.requestMethod(
      `work/Actions`,
      'GET',
      true,
      null,
    );
  }

  searchCompany(data): Observable<any> {
    return this._requestService.requestMethod(
      `company/api/Company/ListCompanyByName`,
      'POST',
      true,
      data,
    );
  }

  listWorksByCompany(data): Observable<any> {
    return this._requestService.requestMethod(
      `work/ListWorksbyCompany`,
      'POST',
      true,
      data,
    );
  }

  listWorksByWorksOrID(data): Observable<any> {
    return this._requestService.requestMethod(
      `work/ListWorksbyNameOrID`,
      'POST',
      true,
      data,
    );
  }

  updateWorks(update: any): Observable<any> {
    return this._requestService.requestMethod(
      `work/Search/RealState/UpdateSelected`,
      'PUT',
      true,
      update,
    );
  }

  exportWorksCompany(data?: any, moduleIdFilter?: number): Observable<any> {
    return this._requestService.request(
      `Export/Excel/Work`,
      'POST',
      true,
      { workID: data ?? null, moduleIdFilter: moduleIdFilter.toString() },
      { 'Content-Type': 'application/json' },
      'blob',
    );
  }

  listSavedSearches(data): Observable<any> {
    return this._requestService.requestMethod(
      `work/ListSavedSearchesOfWorks`,
      'POST',
      true,
      data,
    );
  }

  deleteSavedSearch(searchID: number): Observable<any> {
    return this._requestService.requestMethod(
      `work/${searchID}/DeleteSavedSearchesOfWorks`,
      'DELETE',
      true,
      null,
    );
  }

  addResponsible(data): Observable<any> {
    return this._requestService.requestMethod(
      `work/AddJointlyResponsibleSavedSearches`,
      'POST',
      true,
      data,
    );
  }
}
